import { FC } from 'react';
import styled from 'styled-components';

interface DiscountRibbonProps {
  discount: string;
}

const StyledDiscountRibbon = styled.div`
  background-color: #ffe4d9;
  padding: 5px 16.5px;
  border-top-right-radius: 8px;

  .label {
    ${({ theme }) => theme.typo.familyGoogle.semiBold};
    color: ${({ theme }) => theme.color.primaryBase};
    font-size: 15px;
    line-height: 16px;
  }
`;

const DiscountRibbon: FC<DiscountRibbonProps> = ({ discount }) => (
  <StyledDiscountRibbon>
    <div className="label">{discount}</div>
  </StyledDiscountRibbon>
);

const StyledWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;

const DiscountRibbonWrapper: FC<DiscountRibbonProps> = (props) => (
  <StyledWrapper>
    <DiscountRibbon {...props} />
  </StyledWrapper>
);

export { DiscountRibbonWrapper };
export default DiscountRibbon;
